module.exports = __webpack_public_path__ + "static/jeffrey-van-harte-63f9434694aae5102ced9b91d45ee1f9.jpg";